import { render, staticRenderFns } from "./DerivedUnitsWidget.vue?vue&type=template&id=976d2d5c&"
import script from "./DerivedUnitsWidget.vue?vue&type=script&lang=js&"
export * from "./DerivedUnitsWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports